// Actual options are fetched as classifiers, so this is only needed for
// setting the default one
export const DATASET_DROPDOWN_OPTIONS = {
  PRIVATE: 'Private',
  PUBLIC: 'Public',
  BOTH: 'Both',
};
